export default {"src":"/_next/static/media/integration-app-icon.9668ca8f.svg","height":66,"width":67,"blurWidth":0,"blurHeight":0};